/** Expandable OAuth context debug block: hidden when `ENVIRONMENT=production` (local + staging still show it). */
export const SHOW_OAUTH_DEBUG_PANEL = import.meta.env.ENVIRONMENT !== 'production';

/**
 * Hardcoded mapping of role IDs to human-readable permission descriptions.
 *
 * TODO: Move this to @didomi/authorization-metadata package when adding more integrations.
 * For Shopify MVP, keeping it simple and hardcoded here.
 *
 * Future: Add `permissionsSummary` field to role metadata and derive from there.
 */
export const ROLE_PERMISSION_DESCRIPTIONS: Record<string, string[]> = {
  'external-integrations-notices-manager': [
    'Read your notices',
    'Read your notice deployments',
    'Read your SDK configurations',
    'Read your custom partners',
    'Manage this platform integration',
  ],
};
